import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { defaultValues } from '../types/storage/StorageKeyReturnDefaults';
/**
 * @internalapi
 *
 * A storage that can be used in the browser
 */

export var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage(prefix) {
    _classCallCheck(this, LocalStorage);

    this.prefix = prefix;
  }

  _createClass(LocalStorage, [{
    key: "get",
    value: function get(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var value;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                value = localStorage.getItem(this.getPrefixedKey(key));

                if (value) {
                  _context.next = 9;
                  break;
                }

                if (!(typeof defaultValues[key] === 'object')) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", JSON.parse(JSON.stringify(defaultValues[key])));

              case 6:
                return _context.abrupt("return", defaultValues[key]);

              case 7:
                _context.next = 16;
                break;

              case 9:
                _context.prev = 9;
                return _context.abrupt("return", JSON.parse(value));

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](9);
                return _context.abrupt("return", value);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 13]]);
      }));
    }
  }, {
    key: "set",
    value: function set(key, value) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(typeof value === 'string')) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return", localStorage.setItem(this.getPrefixedKey(key), value));

              case 4:
                return _context2.abrupt("return", localStorage.setItem(this.getPrefixedKey(key), JSON.stringify(value)));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", Promise.resolve(localStorage.removeItem(this.getPrefixedKey(key))));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getPrefixedKey",
    value: function getPrefixedKey(key) {
      return this.prefix ? "".concat(this.prefix, "-").concat(key) : key;
    }
  }], [{
    key: "isSupported",
    value: function isSupported() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", Promise.resolve(Boolean(typeof window !== 'undefined') && Boolean(window.localStorage)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }]);

  return LocalStorage;
}();